import {
    Box,
    Stack,
    FormControl,
    Grid,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton,
    Paper,
    Avatar,
    TextField,
    Typography,
    Button,
    CircularProgress,
    Modal,
    Divider,
    FormControlLabel,
    RadioGroup,
    Radio,
    Tooltip,
    Select,
    MenuItem,
    Link,
    ToggleButtonGroup,
    ToggleButton,
    FormLabel,
    FormHelperText,
    FormGroup,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { RootState } from '../../reducers';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import { DataGrid, gridClasses, GridColDef } from '@mui/x-data-grid';
import { Search } from '@mui/icons-material';
import { parentUrl, modalStyle } from '../../utils/constants';
import Loading from '../Shared/Loading';
import { isValid } from 'date-fns';
import { toDate, formatDate } from '../../utils/dateHelpers';
import ArticleIcon from '@mui/icons-material/Article';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { localDateFormat } from '../../utils/timeFormat';
import { isDefaultDate } from '../../utils/common';
import { fetchMembersByKeyword, fetchMemberStatuses, setMembers } from '../../store/members.slice';
import { getMemberById } from '../../store/memberDetail.slice';
import { hedisMetricsList, submitHedisMetricVisit, setShowHedisUpdateModal, updateHedisMetricManually } from '../../store/memberDemographicsDetails.slice';
import { getMetaTagsByCategoryId } from '../../store/memberDocuments.slice';
import { ClaimSourceEnum } from '../../Enum/ClaimSourceEnum';
import { HedisMetricsVisit } from '../../Models/HedisMetrics/HedisMetricsVisit.model';
import StarIcon from '@mui/icons-material/Star';
import phoneFormat from '../../utils/phoneFormat';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { HedisMetricStatusEnum } from '../../Enum/HedisMetricStatusEnum';
import { Form, Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import ScienceIcon from '@mui/icons-material/Science';
import { noteFormatter } from '../HIE/Modals/TeamNotificationModal';
import HelpIcon from '@mui/icons-material/Help';
import hedisHelpDocument from '../../assets/documents/Hedis_Tile_Help.pdf';
import { HedisMetricsTypeEnum } from '../../Enum/HedisMetricsTypeEnum';
import Authorization from '../../utils/Authorization';
import { formatUtcDate } from '../../utils/timeFormat';

const manuallyUpdateHedisList = [
    {
        Id: HedisMetricsTypeEnum.ProviderVisits,
        Name: HedisMetricsTypeEnum.ProviderVisitText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.BMI,
        Name: HedisMetricsTypeEnum.BmiText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.BP,
        Name: HedisMetricsTypeEnum.BpText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.BreastCancerScreening,
        Name: HedisMetricsTypeEnum.BreastCancerText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.DepressionFollowUp,
        Name: HedisMetricsTypeEnum.DepressionFollowUpText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.DepressionScreening,
        Name: HedisMetricsTypeEnum.DepressionScreeningText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.HgbA1c,
        Name: HedisMetricsTypeEnum.HgbA1cText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.LipidForBhDx,
        Name: HedisMetricsTypeEnum.LipidForBhDxText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.HgbA1cForBhDx,
        Name: HedisMetricsTypeEnum.HgbA1cForBhDxText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.MedicationReconciliation,
        Name: HedisMetricsTypeEnum.MedicationReconciliationText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.ColorectalCancerScreening,
        Name: HedisMetricsTypeEnum.ColorectalCancerScreeningText,
        IsEnabled: false,
    },
    {
        Id: HedisMetricsTypeEnum.CervicalCancerScreening,
        Name: HedisMetricsTypeEnum.CervicalCancerScreeningText,
        IsEnabled: false,
    },
];

const claimsSourceList = [
    {
        Id: ClaimSourceEnum.ChpClaims,
        Name: ClaimSourceEnum.ChpClaimsDescription,
    },
    {
        Id: ClaimSourceEnum.External,
        Name: ClaimSourceEnum.ExternalDescription,
    },
    {
        Id: ClaimSourceEnum.HealthPlan,
        Name: ClaimSourceEnum.HealthPlanDescription,
    },
];

const MemberHedisMetrics = (props) => {
    const dispatch = useAppDispatch();
    const auth = new Authorization();
    const { isLoading } = useSelector((state: RootState) => state.shared);
    const { members, memberStatuses, isFetchingMember } = useSelector((state: RootState) => state.members);
    const { showHedisUpdateModal } = useSelector((state: RootState) => state.memberDemographicsDetails);
    const { memberHealthPlans } = useSelector((state: RootState) => state.memberDetail);
    const { metaTagsByCategoryId } = useSelector((state: RootState) => state.memberDocuments);
    const [selectedMember, setSelectedMember] = useState(null);
    const [hedisDetail, setHedisDetail] = useState<HedisMetricsVisit>(null);
    const [memberSearchValue, setMemberSearchValue] = useState('');
    const [hedisType, setHedisType] = useState<string>('');
    const [isFetching, setIsFetching] = useState<boolean>(false);
    const [showHedisDetail, setShowHedisDetail] = useState(false);
    const [showManuallyEnabledHedisPopup, setShowManuallyEnabledHedisPopup] = useState(false);
    const hasHedisMetricManagementPermission = auth.Permissions.includes('Hedis Metric Management') ? true : false;
    const hasDisablePermission = auth.Permissions.includes('Allow Disable HEDIS Metrics') ? true : false;
    const [paginationModel, setPaginationModel] = useState({ pageSize: 10, page: 0 });
    const [selectedValues, setSelectedValues] = useState<{ [key: string]: string }>({});

    const executeSearch = (event: any) => {
        if (Boolean(event.target.value) && (!event.key || event.key === 'Enter')) {
            dispatch(fetchMembersByKeyword(event.target.value));
            setMemberSearchValue(event.target.value);
            setSelectedMember(null);
        } else if (!Boolean(event.target.value)) {
            dispatch(setMembers([]));
            setSelectedMember(null);
        }
    };

    const iconSearch = () => {
        if (Boolean(memberSearchValue)) {
            dispatch(fetchMembersByKeyword(memberSearchValue));
            setMemberSearchValue(memberSearchValue);
            setSelectedMember(null);
        } else {
            dispatch(setMembers([]));
            setSelectedMember(null);
        }
    };

    useEffect(() => {
        dispatch(getMetaTagsByCategoryId('58095a82787ba42fcc404505'));
        dispatch(fetchMemberStatuses());
        document.title = props.title;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    const membersColumns: GridColDef[] = [
        {
            field: 'AhcccsId',
            headerName: 'AHCCCS ID',
            flex: 1,
        },
        {
            field: 'LastName',
            headerName: 'Last Name',
            flex: 1,
        },
        {
            field: 'FirstName',
            headerName: 'First Name',
            flex: 1,
        },
        {
            field: 'DOB',
            headerName: 'DOB',
            width: 100,
            valueGetter: (value, row) => `${isDefaultDate(row.DOB) ? '-' : localDateFormat(new Date(row.DOB))}`,
            sortable: false,
        },
    ];

    const prepareSelectedMember = (memberId: string) => {
        setIsFetching(true);
        dispatch(
            getMemberById(memberId, (data) => {
                setSelectedMember(data);
                if (data !== undefined) {
                    setSelectedValues(
                        Object.fromEntries(
                            manuallyUpdateHedisList.map((el) => [
                                el.Id,
                                data.EnabledHedisTiles?.includes(el.Id) ? 'enable' : data.DisabledHedisTiles?.includes(el.Id) ? 'disable' : 'auto',
                            ])
                        )
                    );
                }
                setIsFetching(false);
            })
        );
    };

    const fontColor = (metric) => {
        if (metric?.IsApplicable) {
            if (metric?.IsExpired || metric?.MetricStatus === HedisMetricStatusEnum.Expired) {
                return 'error.main';
            } else if (metric?.MetricStatus === HedisMetricStatusEnum.Completed || metric?.MetricStatus === HedisMetricStatusEnum.CompletedAndControlled) {
                return 'success.main';
            } else if (metric?.MetricStatus === HedisMetricStatusEnum.CompletedAndNotControlled) {
                return 'warning.main';
            } else {
                return 'rgba(0,0,0,0.8)';
            }
        } else {
            return 'rgba(0,0,0,0.4)';
        }
    };

    const iconColor = (metric) => {
        if (metric?.IsApplicable) {
            if (metric?.IsExpired || metric?.MetricStatus === HedisMetricStatusEnum.Expired) {
                return 'error';
            } else if (metric?.MetricStatus === HedisMetricStatusEnum.Completed || metric?.MetricStatus === HedisMetricStatusEnum.CompletedAndControlled) {
                return 'success';
            } else if (metric?.MetricStatus === HedisMetricStatusEnum.CompletedAndNotControlled) {
                return 'warning';
            } else {
                return 'rgba(0,0,0,0.8)';
            }
        } else {
            return 'disabled';
        }
    };

    const prepareHedis = (metric: HedisMetricsVisit, hedisType: string) => {
        setHedisDetail(metric);
        setHedisType(hedisType);
        setShowHedisDetail(true);
    };

    const prepareHedisStatus = (metric) => {
        if (metric?.IsExpired || metric?.MetricStatus === HedisMetricStatusEnum.Expired) {
            return `Expired`;
        } else if (metric?.MetricStatus === HedisMetricStatusEnum.Completed) {
            return `Completed`;
        } else if (metric?.MetricStatus === HedisMetricStatusEnum.CompletedAndControlled) {
            return `Completed And Controlled`;
        } else if (metric?.MetricStatus === HedisMetricStatusEnum.CompletedAndNotControlled) {
            return `Completed And Not Controlled`;
        }
    };

    const handleSubmit = (values: HedisMetricsVisit) => {
        dispatch(
            submitHedisMetricVisit(selectedMember.Id, values, values.File, (data) => {
                setSelectedMember(data);
            })
        );
    };

    const navigateToMemberDashboard = (id: any) => {
        window.open(`${parentUrl}provider/members-list/member-chart/${id}/member-profile`, '_blank');
    };

    const onCheckHandler = (hedisType: string, type: number) => {
        let labReport = metaTagsByCategoryId.find((m) => m.Name === 'Lab Reports').Id;
        let metricData = {
            HedisMetricType: type,
            IsMetAtThisVisit: true,
            DateLastMet: new Date(),
            DocumentMetaTag: labReport,
            ClaimSource: 4,
            DateUpdatedByHealthPlan: new Date(),
        } as HedisMetricsVisit;
        setHedisDetail(metricData);
        setHedisType(hedisType);
        dispatch(setShowHedisUpdateModal(true));
    };

    const showStar = (team) => {
        if (!team) return false;
        if (team?.Id === selectedMember?.Team?.Id) return true;
        return false;
    };

    const hedisFormSchema = Yup.object().shape({
        DateLastMet: Yup.string().nullable().required('Date is required.'),
        DateUpdatedByHealthPlan: Yup.string().when('ClaimSource', {
            is: (val: number) => val === ClaimSourceEnum.HealthPlan,
            then: Yup.string().nullable().required('Date is required.'),
        }),
        Note: Yup.string().nullable().required('Note is required.'),
        File: Yup.mixed().when('ClaimSource', {
            is: (val: number) => val === ClaimSourceEnum.External,
            then: Yup.mixed().nullable().required('File is required.'),
        }),
    });

    const prepareHedisDetail = () => {
        var hedisDetail = [];
        hedisMetricsList.forEach((metric, index) => {
            let metricInfo = selectedMember.HedisSummary.find((h) => h.HedisMetricType === metric.type);
            let metricInfoCopy = {
                ...metricInfo,
                Label: metric.label,
                Type: metric.type,
                FontColor: fontColor(metricInfo),
                IconColor: iconColor(metricInfo),
                IsApplicable:
                    metric.type === HedisMetricsTypeEnum.DepressionFollowUp || metric.type === HedisMetricsTypeEnum.DepressionScreening
                        ? false
                        : metricInfo?.IsApplicable,
            };
            hedisDetail.push(metricInfoCopy);
        });
        return hedisDetail;
    };

    const handleChange = (id: any, value: string) => {
        setSelectedValues((prev) => ({ ...prev, [id]: value }));
    };

    const updateMetricsManually = () => {
        const enabledList = manuallyUpdateHedisList.filter((el) => selectedValues[el.Id] === 'enable').map((el) => el.Id);
        const disabledList = manuallyUpdateHedisList.filter((el) => selectedValues[el.Id] === 'disable').map((el) => el.Id);
        dispatch(
            updateHedisMetricManually(selectedMember.Id, enabledList, disabledList, (data) => {
                setIsFetching(true);
                setSelectedMember(data);
                setIsFetching(false);
                setShowManuallyEnabledHedisPopup(false);
            })
        );
    };

    return (
        <Box>
            <Grid container paddingBottom={0}>
                <Stack direction="row" width="100%" spacing={4} paddingX={2} paddingTop={2} sx={{ zIndex: 10, background: '#ffffff' }}>
                    <Grid size={3}>
                        <Stack direction={'row'} spacing={1} alignItems={'center'}>
                            <FormControl fullWidth style={{ marginTop: '16px', marginBottom: '16px' }}>
                                <InputLabel htmlFor="outlined-adornment-password">Search</InputLabel>
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type="text"
                                    onChange={(e) => {
                                        setMemberSearchValue(e.target.value as string);
                                    }}
                                    onKeyUp={(event: any) => {
                                        executeSearch(event);
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Search"
                                                onClick={(event: any) => {
                                                    iconSearch();
                                                }}
                                                edge="end"
                                            >
                                                <Search />
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    label="Search"
                                />
                            </FormControl>
                            <Tooltip title="HEDIS Metrics Help Document">
                                <HelpIcon color="primary" cursor="pointer" onClick={() => window.open(`${hedisHelpDocument}`, '_blank')} />
                            </Tooltip>
                        </Stack>
                        <div style={{ width: '100%' }}>
                            <DataGrid
                                loading={isFetchingMember}
                                onCellClick={(params: any) => {
                                    prepareSelectedMember(params.row.Id);
                                }}
                                autoHeight
                                rows={memberSearchValue ? members : []}
                                columns={membersColumns}
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                                pageSizeOptions={[5]}
                                getRowId={(row) => row.Id}
                                sx={{
                                    [`& .${gridClasses.cell}`]: {
                                        py: 1,
                                    },
                                    minHeight: '67vh',
                                }}
                                localeText={{ noRowsLabel: Boolean(memberSearchValue) ? 'No member found' : 'Type and enter to search the members' }}
                            />
                        </div>
                    </Grid>
                    <Grid size={9}>
                        {isFetching ? (
                            <Paper className="loader-container" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '74vh', mt: 2 }}>
                                <CircularProgress size={50} />
                            </Paper>
                        ) : Boolean(selectedMember) ? (
                            <>
                                <Paper elevation={3} style={{ padding: '8px', marginTop: '16px', marginBottom: '16px', textAlign: 'left' }}>
                                    <Stack direction="row" spacing={2}>
                                        <Stack spacing={2}>
                                            <Avatar
                                                alt={selectedMember.FirstName + ' ' + selectedMember.LastName}
                                                src={selectedMember.Photo}
                                                sx={{ width: 136, height: 136 }}
                                                className="profile-image"
                                            />
                                            <Button
                                                variant="outlined"
                                                onClick={() => {
                                                    navigateToMemberDashboard(selectedMember.Id);
                                                }}
                                            >
                                                View Chart
                                            </Button>
                                        </Stack>
                                        <Grid container spacing={1}>
                                            <Paper square elevation={3} sx={{ p: 2, display: 'flex', width: '100%' }}>
                                                <Grid size={3}>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} borderBottom={1}>
                                                        <Typography variant="body2">First Name:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.FirstName}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Middle Name:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.MiddleName}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Last Name:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.LastName}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">DOB:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.DOB
                                                                ? (() => {
                                                                      const d = toDate(selectedMember?.DOB);
                                                                      return d ? formatDate(d, 'MM/dd/yyyy') : '';
                                                                  })()
                                                                : '-'}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Gender:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember.Gender === 1 ? 'Male' : selectedMember.Gender === 2 ? 'Female' : 'Non Declared'}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginX: 2 }} />
                                                <Grid size={3}>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} borderBottom={1}>
                                                        <Typography variant="body2">AHCCCS Id:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.Mem_AHCCCS_ID}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Member Id:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.MemberId}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Status:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {memberStatuses.find((m) => parseInt(m.value) === selectedMember.Status).label || ''}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Health Plan:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.ContractingHealthPlan?.Name}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1.2} borderBottom={1}>
                                                        <Typography variant="body2">Insurance:</Typography>
                                                        <Grid container columnGap={2} justifyContent={'flex-end'}>
                                                            {memberHealthPlans.map((plan, index) => {
                                                                return (
                                                                    <Grid display={'flex'} key={index}>
                                                                        <Typography textAlign={'right'} fontStyle={'italic'} variant="body2" marginRight={1}>
                                                                            {plan.Priority ? plan.Priority : '-'}
                                                                        </Typography>
                                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                                            {plan?.Name ? plan?.Name : '-'}
                                                                        </Typography>
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>
                                                    </Stack>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginX: 2 }} />
                                                <Grid size={3}>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={1} borderBottom={1}>
                                                        <Typography variant="body2">CC:</Typography>
                                                        <Typography fontWeight={700} variant="body2">
                                                            {selectedMember?.CCTeam?.Name || ''}
                                                            {showStar(selectedMember?.CCTeam) && (
                                                                <StarIcon color="primary" sx={{ fontSize: '1rem', marginLeft: '5px' }} />
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={1} marginTop={1} borderBottom={1}>
                                                        <Typography variant="body2">NP:</Typography>
                                                        <Typography fontWeight={700} variant="body2">
                                                            {selectedMember?.NPTeam?.Name || ''}
                                                            {showStar(selectedMember?.NPTeam) && (
                                                                <StarIcon color="primary" sx={{ fontSize: '1rem', marginLeft: '5px' }} />
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={1} marginTop={1} borderBottom={1}>
                                                        <Typography variant="body2">BH:</Typography>
                                                        <Typography fontWeight={700} variant="body2">
                                                            {selectedMember?.BHTeam?.Name || ''}
                                                            {showStar(selectedMember?.BHTeam) && (
                                                                <StarIcon color="primary" sx={{ fontSize: '1rem', marginLeft: '5px' }} />
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={1} marginTop={1} borderBottom={1}>
                                                        <Typography variant="body2">CL:</Typography>
                                                        <Typography fontWeight={700} variant="body2">
                                                            {selectedMember?.CLTeam?.Name || ''}
                                                            {showStar(selectedMember?.CLTeam) && (
                                                                <StarIcon color="primary" sx={{ fontSize: '1rem', marginLeft: '5px' }} />
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={1} marginTop={1} borderBottom={1}>
                                                        <Typography variant="body2">CHW:</Typography>
                                                        <Typography fontWeight={700} variant="body2">
                                                            {selectedMember?.CHWTeam?.Name || ''}
                                                            {showStar(selectedMember?.CHWTeam) && (
                                                                <StarIcon color="primary" sx={{ fontSize: '1rem', marginLeft: '5px' }} />
                                                            )}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                                <Divider orientation="vertical" flexItem sx={{ marginX: 2 }} />
                                                <Grid size={3}>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} borderBottom={1}>
                                                        <Typography variant="body2">Address:</Typography>
                                                        <Stack justifyContent={'flex-end'} spacing={0}>
                                                            <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                                {`${selectedMember?.MainAddress?.Address1 ? selectedMember?.MainAddress?.Address1 : '-'}${
                                                                    selectedMember?.MainAddress?.Address2 ? ', ' + selectedMember?.MainAddress?.Address2 : ''
                                                                } `}
                                                            </Typography>
                                                            <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                                {`${selectedMember?.MainAddress?.City ? selectedMember?.MainAddress?.City : '-'}${
                                                                    selectedMember?.MainAddress?.State ? ', ' + selectedMember?.MainAddress?.State : ''
                                                                } ${selectedMember?.MainAddress?.ZipCode ? selectedMember?.MainAddress?.ZipCode : ''}`}
                                                            </Typography>
                                                        </Stack>
                                                    </Stack>
                                                    {selectedMember.IsDifferMeetingAddress && (
                                                        <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1} borderBottom={1}>
                                                            <Typography variant="body2">Meeting Address:</Typography>
                                                            <Stack justifyContent={'flex-end'} spacing={0}>
                                                                <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                                    {`${
                                                                        selectedMember?.MainMeetingAddress?.Address1
                                                                            ? selectedMember?.MainMeetingAddress?.Address1
                                                                            : '-'
                                                                    }${
                                                                        selectedMember?.MainMeetingAddress?.Address2
                                                                            ? ', ' + selectedMember?.MainMeetingAddress?.Address2
                                                                            : ''
                                                                    } `}
                                                                </Typography>
                                                                <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                                    {`${
                                                                        selectedMember?.MainMeetingAddress?.City
                                                                            ? selectedMember?.MainMeetingAddress?.City
                                                                            : '-'
                                                                    }${
                                                                        selectedMember?.MainMeetingAddress?.State
                                                                            ? ', ' + selectedMember?.MainMeetingAddress?.State
                                                                            : ''
                                                                    } ${
                                                                        selectedMember?.MainMeetingAddress?.ZipCode
                                                                            ? selectedMember?.MainMeetingAddress?.ZipCode
                                                                            : ''
                                                                    }`}
                                                                </Typography>
                                                            </Stack>
                                                        </Stack>
                                                    )}
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1} borderBottom={1}>
                                                        <Typography variant="body2">Phones:</Typography>
                                                        <Grid container columnGap={2} justifyContent={'flex-end'}>
                                                            {selectedMember?.Phones?.map((phone, index) => {
                                                                return (
                                                                    <Grid
                                                                        key={index}
                                                                        display={'flex'}
                                                                        color={phone.IsPrimary ? 'primary.main' : 'rgba(0,0,0,0.5)'}
                                                                    >
                                                                        <Typography textAlign={'right'} variant="body2" marginRight={1}>
                                                                            {phone.Textable ? 'Text -' : 'No Text -'}
                                                                        </Typography>
                                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                                            {phone.Number ? phoneFormat(phone.Number) : '-'}
                                                                        </Typography>
                                                                        {phone.IsPrimary && (
                                                                            <Tooltip title="Primary Phone">
                                                                                <StarIcon color="primary" sx={{ fontSize: '1rem', marginLeft: 1 }} />
                                                                            </Tooltip>
                                                                        )}
                                                                    </Grid>
                                                                );
                                                            })}
                                                        </Grid>
                                                    </Stack>
                                                    <Stack direction={'row'} justifyContent={'space-between'} spacing={2} marginTop={1} borderBottom={1}>
                                                        <Typography variant="body2">Primary Language:</Typography>
                                                        <Typography textAlign={'right'} fontWeight={700} variant="body2">
                                                            {selectedMember?.PrimaryLanguage?.Name}
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Paper>
                                        </Grid>
                                    </Stack>
                                </Paper>
                                <Paper elevation={3} style={{ padding: '8px', marginTop: '16px', marginBottom: '16px', textAlign: 'left' }}>
                                    <Stack direction={'row'} spacing={2} sx={{ backgroundColor: 'white' }} justifyContent={'center'}>
                                        <Typography variant="body2" fontWeight={'bold'} color={'error.main'}>
                                            Expired
                                        </Typography>
                                        <Typography variant="body2" fontWeight={'bold'} color={'success.main'}>
                                            Applicable And Controlled
                                        </Typography>
                                        <Typography variant="body2" fontWeight={'bold'} color={'warning.main'}>
                                            Applicable And Not Controlled
                                        </Typography>
                                    </Stack>
                                </Paper>
                                <Paper elevation={3} style={{ padding: '8px', marginTop: '16px', marginBottom: '16px', textAlign: 'left' }}>
                                    <Stack direction={'row'} spacing={2} sx={{ backgroundColor: 'white' }} justifyContent={'center'}>
                                        <Button
                                            disabled={!hasHedisMetricManagementPermission}
                                            variant="outlined"
                                            onClick={() => {
                                                setShowManuallyEnabledHedisPopup(true);
                                            }}
                                        >
                                            Enable / Disable HEDIS Metrics
                                        </Button>
                                    </Stack>
                                    <Grid container sx={{ backgroundColor: 'white' }} justifyContent={'center'}>
                                        {prepareHedisDetail().map((metric, index) => {
                                            if (metric.HedisAlert) {
                                                console.log('metric.HedisAlert ', metric);
                                            }

                                            const fontColor = metric.FontColor;
                                            const iconColor = metric.IconColor;
                                            return (
                                                <Grid size={3} p={1.5} textAlign={'center'} key={index}>
                                                    <Paper
                                                        elevation={3}
                                                        sx={{ p: 1, minHeight: 60, borderLeftWidth: 4, borderLeftColor: fontColor, borderLeftStyle: 'solid' }}
                                                    >
                                                        <Typography fontWeight={700} color={fontColor} variant="body1" pb={0.6}>
                                                            {metric.Label}
                                                            <ArticleIcon
                                                                color={iconColor}
                                                                sx={{
                                                                    fontSize: '1rem',
                                                                    cursor: Boolean(metric?.DateLastMet) ? 'pointer' : '',
                                                                    margin: '0 0 -2px 3px',
                                                                    paddingLeft: '5px',
                                                                }}
                                                                onClick={() => Boolean(metric?.DateLastMet) && prepareHedis(metric, metric?.Label)}
                                                            />
                                                            {Boolean(metric?.HedisAlert) ? (
                                                                <ScienceIcon
                                                                    aria-label="delete"
                                                                    color={iconColor}
                                                                    sx={{
                                                                        fontSize: '1.1rem',
                                                                        cursor: Boolean(metric?.DateLastMet) ? 'pointer' : '',
                                                                        margin: '0 0 -2px 3px',
                                                                        paddingLeft: '5px',
                                                                    }}
                                                                    onClick={() => Boolean(metric?.DateLastMet) && prepareHedis(metric, metric?.Label)}
                                                                />
                                                            ) : null}
                                                        </Typography>
                                                        <Typography color={fontColor} variant="body2">
                                                            {metric?.DateLastMet && !metric?.IsMetAtThisVisit ? 'Last Not Met : ' : 'Last Met : '}
                                                            {formatUtcDate(metric?.DateLastMet)}
                                                        </Typography>
                                                        <Button
                                                            disabled={!(metric.IsApplicable && hasHedisMetricManagementPermission)}
                                                            sx={{ marginTop: '10px', textTransform: 'none', color: fontColor, borderColor: fontColor }}
                                                            variant="outlined"
                                                            size="small"
                                                            onClick={(e) => onCheckHandler(metric.Label, metric.Type)}
                                                        >
                                                            Status at this visit
                                                        </Button>
                                                    </Paper>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Paper>
                            </>
                        ) : (
                            <>
                                <Loading message={'Loading...'} />
                                <Paper elevation={3} style={{ padding: '8px', marginTop: '16px', marginBottom: '16px', textAlign: 'left' }}>
                                    <Stack direction="row" spacing={2}>
                                        <Typography variant="h5" p={0.5}>
                                            Search and select a member to view the HEDIS details.
                                        </Typography>
                                    </Stack>
                                </Paper>
                            </>
                        )}
                    </Grid>
                </Stack>
            </Grid>
            <Modal
                open={showHedisUpdateModal}
                onClose={() => {
                    dispatch(setShowHedisUpdateModal(false));
                    setHedisDetail(null);
                }}
            >
                <Box sx={modalStyle} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <Stack spacing={2}>
                        <Typography variant="h5">{hedisType}</Typography>
                        <Divider />
                    </Stack>
                    <Formik
                        initialValues={hedisDetail || ({} as HedisMetricsVisit)}
                        enableReinitialize={true}
                        onSubmit={handleSubmit}
                        validationSchema={hedisFormSchema}
                    >
                        {({ values, setFieldValue, errors, handleChange, handleBlur, validateForm, submitCount }: FormikProps<HedisMetricsVisit>) => (
                            <Form>
                                <div className="mui-modal-body">
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <Grid container direction="column" spacing={2} className="content-panel">
                                            <Grid className="content-form">
                                                <Grid container paddingTop={2} spacing={2}>
                                                    <Grid size={3}>
                                                        <FormControl>
                                                            <RadioGroup
                                                                row
                                                                name="IsMetAtThisVisit"
                                                                value={Boolean(values?.IsMetAtThisVisit) ? 'Yes' : 'No'}
                                                                onChange={(e) => {
                                                                    setFieldValue('IsMetAtThisVisit', e.target.value === 'Yes');
                                                                }}
                                                            >
                                                                <FormControlLabel
                                                                    sx={{ marginRight: '5px' }}
                                                                    value="Yes"
                                                                    control={<Radio color="success" />}
                                                                    label="Met"
                                                                />
                                                                <FormControlLabel sx={{ m: 0 }} value="No" control={<Radio color="error" />} label="Not Met" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid size={2.5} mr={2}>
                                                        <DatePicker
                                                            label="Date Last Met"
                                                            value={values?.DateLastMet ? new Date(values.DateLastMet) : null}
                                                            minDate={new Date('2017-01-01')}
                                                            onChange={(date) => {
                                                                if (
                                                                    (() => {
                                                                        const d = toDate(date);
                                                                        return d && isValid(d);
                                                                    })()
                                                                ) {
                                                                    setFieldValue('DateLastMet', date);
                                                                } else {
                                                                    setFieldValue('DateLastMet', '');
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    fullWidth: true,
                                                                    error: Boolean(errors?.DateLastMet) && Boolean(submitCount),
                                                                    helperText:
                                                                        Boolean(submitCount) && Boolean(errors?.DateLastMet) ? String(errors?.DateLastMet) : '',
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid size={2.6}>
                                                        <FormControl>
                                                            <InputLabel>Claim Source</InputLabel>
                                                            <Select
                                                                style={{ width: 150 }}
                                                                value={values?.ClaimSource}
                                                                label="Claim Source"
                                                                onChange={(e) => {
                                                                    setFieldValue('ClaimSource', parseInt(e.target.value.toString()));
                                                                }}
                                                            >
                                                                {claimsSourceList.map((item, index) => (
                                                                    <MenuItem key={`${item.Id}-${index}`} value={item.Id}>
                                                                        {item.Name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    {values?.ClaimSource === ClaimSourceEnum.HealthPlan && (
                                                        <Grid size={3.4} mr={2}>
                                                            <DatePicker
                                                                label="Health Plan Notification Date"
                                                                value={values?.DateUpdatedByHealthPlan ? new Date(values.DateUpdatedByHealthPlan) : null}
                                                                minDate={new Date('2017-01-01')}
                                                                onChange={(date) => {
                                                                    if (
                                                                        (() => {
                                                                            const d = toDate(date);
                                                                            return d && isValid(d);
                                                                        })()
                                                                    ) {
                                                                        setFieldValue('DateUpdatedByHealthPlan', date.toISOString());
                                                                    } else {
                                                                        setFieldValue('DateUpdatedByHealthPlan', '');
                                                                    }
                                                                }}
                                                                slotProps={{
                                                                    textField: {
                                                                        fullWidth: true,
                                                                        error: Boolean(errors?.DateUpdatedByHealthPlan) && Boolean(submitCount),
                                                                        helperText:
                                                                            Boolean(submitCount) && Boolean(errors?.DateUpdatedByHealthPlan)
                                                                                ? String(errors?.DateUpdatedByHealthPlan)
                                                                                : '',
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                    )}
                                                </Grid>
                                                <Stack spacing={2} mt={1.5}>
                                                    <TextField
                                                        style={{ width: '100%', marginTop: '10px' }}
                                                        id="outlined-multiline-static"
                                                        label="Note"
                                                        multiline
                                                        rows={6}
                                                        value={values?.Note || ''}
                                                        onChange={(e) => {
                                                            setFieldValue('Note', e.target.value);
                                                        }}
                                                        error={Boolean(errors?.Note) && Boolean(submitCount)}
                                                        helperText={Boolean(submitCount) && Boolean(errors?.Note) ? String(errors?.Note) : ''}
                                                    />
                                                </Stack>
                                                <Grid container paddingTop={1} spacing={2} mb={1}>
                                                    <Grid size={12}>
                                                        <FormControl fullWidth margin="normal">
                                                            <FormLabel sx={{ pb: '5px' }}>Meta Data Tags</FormLabel>
                                                            <ToggleButtonGroup
                                                                sx={{ display: 'flex' }}
                                                                exclusive
                                                                value={values?.DocumentMetaTag}
                                                                color="primary"
                                                                onChange={(e, value) => {
                                                                    setFieldValue('DocumentMetaTag', value);
                                                                }}
                                                            >
                                                                {metaTagsByCategoryId.length > 0 &&
                                                                    metaTagsByCategoryId.map((tag) => {
                                                                        return (
                                                                            <ToggleButton key={tag.Id} value={tag.Id}>
                                                                                {tag.Name}
                                                                            </ToggleButton>
                                                                        );
                                                                    })}
                                                            </ToggleButtonGroup>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                                <Grid container paddingTop={2} spacing={2} mb={3}>
                                                    <Grid size={12}>
                                                        <Stack spacing={2}>
                                                            <form id={'upload-form'}>
                                                                <Button
                                                                    variant="contained"
                                                                    id="upload-btn"
                                                                    component="label"
                                                                    sx={{ textAlign: 'center' }}
                                                                    startIcon={<CloudUploadIcon />}
                                                                >
                                                                    Choose Document To Upload
                                                                    <input
                                                                        id="file"
                                                                        name="File"
                                                                        type="file"
                                                                        accept="application/pdf"
                                                                        hidden
                                                                        onChange={(e) => {
                                                                            setFieldValue('File', e.target.files[0]);
                                                                        }}
                                                                    />
                                                                </Button>
                                                                <FormHelperText error>
                                                                    {Boolean(submitCount) && Boolean(errors?.File) ? String(errors?.File) : ''}
                                                                </FormHelperText>
                                                            </form>
                                                            <Typography variant="subtitle1">{values?.File ? values?.File?.name : ''}</Typography>
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </LocalizationProvider>
                                </div>
                                <Divider />
                                <Stack direction="row" spacing={2} style={{ float: 'right' }} pt={1} mt={1}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={isLoading}
                                        endIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : null}
                                    >
                                        {isLoading ? 'Submiting...' : 'Submit'}
                                    </Button>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        disabled={isLoading}
                                        onClick={() => {
                                            dispatch(setShowHedisUpdateModal(false));
                                            setHedisDetail(null);
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Stack>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal>
            <Modal
                open={showHedisDetail}
                onClose={() => {
                    setShowHedisDetail(false);
                }}
            >
                <Box sx={modalStyle} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <Stack spacing={1}>
                        <Typography variant="h5">
                            {hedisType}
                            <Typography variant="body1" sx={{ color: fontColor(hedisDetail), fontSize: 14 }}>
                                {prepareHedisStatus(hedisDetail)}
                            </Typography>
                        </Typography>
                        <Divider />
                    </Stack>
                    <Stack spacing={2} mt={2}>
                        <Stack direction="row" spacing={2}>
                            <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                CPT Code :
                            </Typography>
                            <Typography>{Boolean(hedisDetail?.CPTcode) ? hedisDetail?.CPTcode : '-'}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={2}>
                            <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                {hedisDetail?.DateLastMet && !hedisDetail.IsMetAtThisVisit ? 'Last Not Met : ' : 'Last Met : '}
                            </Typography>
                            <Typography>{formatUtcDate(hedisDetail?.DateLastMet)}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={2}>
                            <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                Claim Number :
                            </Typography>
                            <Typography>{Boolean(hedisDetail?.ClaimNumber) ? hedisDetail?.ClaimNumber : '-'}</Typography>
                        </Stack>
                        <Stack direction="row" spacing={2}>
                            <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                Claim Source :
                            </Typography>
                            <Typography>
                                {Boolean(hedisDetail?.ClaimSourceName)
                                    ? hedisDetail.ClaimSource === ClaimSourceEnum.ChpClaims && hedisDetail.ProviderName
                                        ? `${hedisDetail.ClaimSourceName} (${hedisDetail.ProviderName})`
                                        : hedisDetail.ClaimSourceName
                                    : '-'}
                            </Typography>
                        </Stack>
                        <Stack direction="row" spacing={2}>
                            <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                Notes :
                            </Typography>
                            <Typography flex={1}>{Boolean(hedisDetail?.Note) ? hedisDetail?.Note : '-'}</Typography>
                        </Stack>
                        {Boolean(hedisDetail?.HedisAlert) && (
                            <Stack direction="row" spacing={2}>
                                <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                    Lab Alert :
                                </Typography>
                                <div>{noteFormatter(hedisDetail?.HedisAlert)}</div>
                            </Stack>
                        )}
                        {hedisDetail?.DocumentUri && (
                            <Stack direction="row" spacing={2}>
                                <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                    Document :
                                </Typography>
                                <Link target="_blank" underline="none" href={hedisDetail?.DocumentUri} sx={{ mt: '4px !important' }}>
                                    {hedisDetail?.DocumentName}
                                </Link>
                            </Stack>
                        )}
                        {hedisDetail?.ClaimSource === ClaimSourceEnum.HealthPlan && (
                            <Stack direction="row" spacing={2}>
                                <Typography fontWeight={700} sx={{ ml: 1, mb: 1.5 }}>
                                    Updated Based On Health Plan :
                                </Typography>
                                <Typography>
                                    {Boolean(hedisDetail?.DateUpdatedByHealthPlan)
                                        ? (() => {
                                              const d = toDate(hedisDetail?.DateUpdatedByHealthPlan);
                                              return d ? formatDate(d, 'MM/dd/yyyy') : '';
                                          })()
                                        : '-'}
                                </Typography>
                            </Stack>
                        )}
                        <Divider />
                        <Box>
                            <Stack direction="row" spacing={1} style={{ float: 'right' }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        setShowHedisDetail(false);
                                        setHedisDetail(null);
                                    }}
                                >
                                    Ok
                                </Button>
                            </Stack>
                        </Box>
                    </Stack>
                </Box>
            </Modal>
            <Modal
                open={showManuallyEnabledHedisPopup}
                onClose={() => {
                    setShowManuallyEnabledHedisPopup(false);
                }}
            >
                <Box sx={{ ...modalStyle, width: '900px' }} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                    <Stack spacing={1}>
                        <Typography variant="h5">Enable / Disable HEDIS Metrics</Typography>
                        <Divider />
                    </Stack>
                    <Grid container rowSpacing={2} columnSpacing={3}>
                        <Grid size={12}>
                            <FormGroup sx={{ paddingTop: '10px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                                {manuallyUpdateHedisList.map((el) => (
                                    <Grid size={4} key={el.Id} pt={1.5} pb={1}>
                                        <Typography variant="h6">{el.Name}</Typography>
                                        <RadioGroup
                                            row
                                            name={`radio-buttons-group-${el.Id}`}
                                            value={selectedValues[el.Id] || ''} // Default value set to 'none'
                                            onChange={(e) => handleChange(el.Id, e.target.value)}
                                        >
                                            <FormControlLabel
                                                value="auto"
                                                control={<Radio color="primary" />}
                                                label="Auto"
                                                sx={{ '& .MuiTypography-root': { fontSize: '13px !important' } }}
                                            />
                                            <FormControlLabel
                                                value="enable"
                                                control={<Radio color="success" />}
                                                label="Enable"
                                                sx={{ '& .MuiTypography-root': { fontSize: '13px !important' } }}
                                            />
                                            <FormControlLabel
                                                disabled={!hasDisablePermission}
                                                value="disable"
                                                control={<Radio color="error" />}
                                                label="Disable"
                                                sx={{ '& .MuiTypography-root': { fontSize: '13px !important' } }}
                                            />
                                        </RadioGroup>
                                    </Grid>
                                ))}
                            </FormGroup>
                        </Grid>
                        <Grid size={12} display="flex" justifyContent={'flex-end'}>
                            <Button
                                className="button-120"
                                sx={{ marginRight: 2 }}
                                type="submit"
                                variant="contained"
                                disabled={isLoading}
                                endIcon={isLoading ? <CircularProgress size={18} color="inherit" /> : null}
                                onClick={() => {
                                    updateMetricsManually();
                                }}
                            >
                                {isLoading ? 'Saving...' : 'Save'}
                            </Button>
                            <Button
                                className="button-120"
                                type="button"
                                variant="outlined"
                                disabled={isLoading}
                                onClick={() => {
                                    setShowManuallyEnabledHedisPopup(false);
                                    setHedisDetail(null);
                                }}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Box>
    );
};

export default MemberHedisMetrics;
